/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramNewsletterControllerCreateNewsletterMutationRequest,
  TelegramNewsletterControllerCreateNewsletterMutationResponse,
} from '../types/TelegramNewsletterControllerCreateNewsletter.ts';

function getTelegramNewsletterCreateNewsletterUrl() {
  const res = { method: 'POST', url: `/api/telegram/newsletter` as const };
  return res;
}

/**
 * {@link /api/telegram/newsletter}
 */
export async function telegramNewsletterCreateNewsletter(
  data: TelegramNewsletterControllerCreateNewsletterMutationRequest,
  config: Partial<RequestConfig<TelegramNewsletterControllerCreateNewsletterMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramNewsletterControllerCreateNewsletterMutationResponse,
    ResponseErrorConfig<Error>,
    TelegramNewsletterControllerCreateNewsletterMutationRequest
  >({
    method: 'POST',
    url: getTelegramNewsletterCreateNewsletterUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
